var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['state', _vm.status.toLowerCase()]},[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.iconName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }